import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class CapitalGainAmountError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CapitalGainAmountError', ...args);
    }
}
export default CapitalGainAmountError;
